/** HACK: обертка для получения значения строкового енума, равного произвольной строке */
export function getStringEnumValue<T extends Record<string, string>>(enumObj: T, string: string | null | undefined) {
	const keyOfNewValue = Object.keys(enumObj).find((key) => enumObj[key as keyof T] === string) as keyof T | undefined;
	return keyOfNewValue ? enumObj[keyOfNewValue] : undefined;
}
